import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralCallback, GeneralInvokeOption, IAnyStrObject } from 'src/types';
import {
  getDataType,
  validateUrl,
  convertObjectValueToString,
  addQueryStringToUrl,
  isObject,
  isString,
  logErrorAndRunFail,
  reportErrorLog
} from '../utils';

export interface RequestOption extends Partial<GeneralInvokeOption> {
  url: string;
  data?: string | Object | ArrayBuffer;
  header?: IAnyStrObject;
  timeout?: number;
  method?: string;
  dataType?: string;
  preload?: GeneralCallback;
}

// 发起https请求
export function request(option: RequestOption) {
  const errorMsg = validateParams(option);
  if (errorMsg) {
    return logErrorAndRunFail(APINames.Native.REQUEST, option, errorMsg);
  }

  if (option.header && !isObject(option.header)) {
    option.header = {};
  }
  option.header = convertObjectValueToString(option.header || {});
  for (const key in option.header) {
    if ('content-type' === key.toLowerCase()) {
      const value = option.header[key];
      delete option.header[key];
      option.header[key.toLowerCase()] = value;
    }
  }
  option.method = option.method ? option.method.toUpperCase() : 'GET';
  option.dataType = option.dataType || 'json';
  option.header['content-type'] =
    option.header['content-type'] || 'application/json';
  let data: any = '';
  if (option.data) {
    data = isObject(option.data) ? JSON.stringify(option.data) : option.data;
  }

  if ('GET' === option.method) {
    option.url = addQueryStringToUrl(option.url, option.data || {});
  }
  const fixOption = Object.assign({ data }, option);
  return MacleJSBridge.beforeInvoke(APINames.Native.REQUEST, fixOption, {
    beforeSuccess(res: any) {
      if (option.dataType !== 'json') {
        return;
      }
      try {
        if (res.data && isString(res.data)) {
          res.data = JSON.parse(res.data);
        }
      } catch (e) {
        reportErrorLog(
          APINames.Native.REQUEST,
          `JSON parse data error from ${option.url}`
        );
      }
    }
  });
}

function validateParams(option: RequestOption) {
  let message: string = '';
  if (!option.url) {
    message =
      'parameter error: parameter.url should be String instead of Undefined.';
  }
  if (!validateUrl(option.url)) {
    message = `parameter error: invalid url ${option.url}`;
  }
  if (option.data && 'Function' === getDataType(option.data)) {
    message = 'parameter error: data should not be Function.';
  }
  return message;
}
